import { colors } from 'theme'

export const defaultThemeStyles = {
    toolbar: colors.white,
    activeItem: colors.clouds
}
